import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
};

const PhotoGridViewerFooterButton = ({ className, label, icon, ...props }) => {
  const classes = classNames({
    'photo-grid-viewer-footer-button': true,
    [className]: !!className,
  });

  return (
    <button className={classes} {...props}>
      {icon}
      <span>{label}</span>
    </button>
  );
};

PhotoGridViewerFooterButton.propTypes = propTypes;

export default PhotoGridViewerFooterButton;
